"use client";

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { validation, validationText } from "../../utils/constants.js";
import { useDispatch, useSelector } from "react-redux";
import { errorToast, formatDate, success } from "../../utils/helpers.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import ThemeTextArea from "../ThemeComponent/ThemeTextArea";
import {
  useAddtaskMutation,
  useUpdatetaskMutation,
} from "../../Redux/services/ClientAPis/taskApi";
import { useGetStaffsQuery } from "../../Redux/services/ClientAPis/staffApi";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";

const AddNewTask = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [option, setOption] = useState([]);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const { data, isSuccess, isFetching } = useGetStaffsQuery(
    {
      search: "",
      limit: pageSize,
      page: page,
    },
    { refetchOnMountOrArgChange: true }
  );

  const [addtask, { isLoading: addLoading }] = useAddtaskMutation();
  const [updatetask, { isLoading }] = useUpdatetaskMutation();

  useEffect(() => {
    if (data) {
      const response = data?.data?.map((x) => {
        return { label: x.name, value: x.id };
      });
      setOption(response);
    }
  }, [data]);

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id };
    try {
      let response;
      if (modalData) {
        response = await updatetask(payload);
      } else {
        response = await addtask(data);
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("title", modalData.title);
      setValue("staff_id", modalData.staff_id);
      setValue("assign_from", modalData.client.name);
      setValue("assign_date", formatDate(modalData.assign_date));
      setValue("completion_date", formatDate(modalData.completion_date));
      setValue("description", modalData.description);
    } else {
      reset();
    }
  }, []);
  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <Row className={"mt-3"}>
          <Col md={6}>
            <ThemeInput
              name="title"
              errors={errors}
              control={control}
              type={"text"}
              className={""}
              placeholder={"Task Title"}
              rules={{
                required: {
                  value: true,
                  message: "Title is required",
                },
              }}
            />
          </Col>
          <Col md={6}>
            <ThemeSelect
              name="staff_id"
              control={control}
              label="Assign To"
              options={option}
              rules={{ required: "Assign to is required" }}
              errors={errors}
              placeholder={"Assign To"}
            />
          </Col>
        </Row>

        <Row className={"mt-3"}>
          <Col md={6}>
            <ThemeInput
              name="assign_from"
              errors={errors}
              control={control}
              type={"text"}
              className={""}
              placeholder={"Assign From"}
              rules={{
                required: {
                  value: true,
                  message: "Assign From is required",
                },
              }}
            />
          </Col>
          <Col md={6}>
            <ThemeInput
              name="assign_date"
              errors={errors}
              control={control}
              type={"date"}
              placeholder={"Assign Date"}
              rules={{
                required: {
                  value: true,
                  message: "Assign Date is required",
                },
              }}
            />
          </Col>
        </Row>

        {/* <ThemeSelect
          name="completion_date"
          control={control}
          label="Completion Date"
          options={options}
          rules={{ required: "Position is required" }}
          errors={errors}
          className={"mt-3"}
          placeholder={"Completion Date"}
        /> */}
        <ThemeInput
          name="completion_date"
          errors={errors}
          control={control}
          type={"date"}
          placeholder={"Completion Date"}
          className={"mt-3"}
          rules={{
            required: {
              value: true,
              message: "Completion Date is required",
            },
          }}
        />
        <ThemeTextArea
          name="description"
          errors={errors}
          control={control}
          type="text"
          placeholder={"Description"}
          rules={{
            required: {
              value: true,
              message: validationText.descriptionRequired,
            },
            maxLength: {
              value: validation.descriptionMax,
              message: validationText.descriptionMax,
            },
          }}
        />

        <div className="d-flex gap-3 mt-4 w-100 justify-content-end">
          <div className="btn-submit w-25">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-25">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
            {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Task"
              ) : (
                "Add Task"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddNewTask;
